import moment from "moment";

export const useBeachCardDisplayInfo = ({ beach, tab }) => {
  let date = null;
  var grade,
    icon,
    label,
    timeframe = moment().subtract(8, "days"),
    timeframe2 = moment().subtract(1, "days");
  const hasAlert =
    beach.hasOwnProperty("currentAlerts") && beach.currentAlerts.length > 0;
  const alert = hasAlert ? beach.currentAlerts[0] : null;
  const hasNowcast =
    beach.hasOwnProperty("nowcast_pass_flag") &&
    moment(beach.nowcast_date).add(7, "hours").isSameOrAfter(timeframe2);
  const nowcast = hasNowcast
    ? parseInt(beach.nowcast_pass_flag) > 0
      ? "good"
      : "poor"
    : null;

  switch (tab) {
    default:
    case 0:
      if (hasAlert) {
        label = "Alert:";
        grade = alert.ActivityType;
        icon = alert.ActivityType;
        date = moment(alert.ActivityStartDate).endOf("day");
      } else if (hasNowcast) {
        label = "NowCast:";
        grade = nowcast;
        icon = nowcast;
        date = moment(beach.nowcast_date).add(7, "hours");
      } else {
        if (
          beach.dry_grade &&
          beach.dry_grade !== "ns" &&
          beach.dry_grade !== "undefined" &&
          moment(beach.grade_updated).isSameOrAfter(timeframe)
        ) {
          label = "Grade:";
          grade = icon = beach.dry_grade;
          date = moment(beach.grade_updated).endOf("day");
        } else if (
          beach.wet_grade &&
          beach.wet_grade !== "ns" &&
          beach.wet_grade !== "undefined" &&
          moment(beach.grade_updated).isSameOrAfter(timeframe)
        ) {
          label = "Grade:";
          grade = icon = beach.wet_grade;
          date = moment(beach.grade_updated).endOf("day");
        } else {
          label = "No Sample";
          grade = "";
          icon = "ns";
          date = null;
        }
      }
      break;
    case 1:
      if (hasNowcast) {
        label = "NowCast:";
        grade = nowcast;
        icon = nowcast;
        date = moment(beach.nowcast_date).add(7, "hours");
      }
      break;
    case 2:
      if (
        beach.dry_grade &&
        beach.dry_grade !== "ns" &&
        beach.dry_grade !== "undefined"
      ) {
        label = "Grade:";
        grade = icon = beach.dry_grade;
        date = moment(beach.grade_updated).endOf("day");
      } else if (
        beach.wet_grade &&
        beach.wet_grade !== "ns" &&
        beach.wet_grade !== "undefined"
      ) {
        label = "Grade:";
        grade = icon = beach.wet_grade;
        date = moment(beach.grade_updated).endOf("day");
      } else {
        label = "No Sample";
        grade = "";
        icon = "ns";
        date = null;
      }
      break;
    case 3:
      if (alert) {
        label = "Alert:";
        grade = alert.ActivityType;
        icon = alert.ActivityType;
        date = null;
      }
      break;
  }

  const image =
    !!!beach.hasOwnProperty("image") && beach.images && beach.images.length > 0
      ? beach.images[0]
      : beach.image || "";

  const header = beach.name1 && beach.name1 !== "" ? beach.name1 : beach.title;
  const subheader =
    beach.name2 && beach.name2 !== "" ? beach.name2 : beach.city;
  const dateGraded = date ? date.fromNow() : "";

  return {
    label,
    grade,
    icon,
    dateGraded,
    image,
    header,
    subheader
  };
};



// WEBPACK FOOTER //
// ./src/components/BeachCard/useBeachCardDisplayInfo.js